import styled from 'styled-components';
import { media, mixins, fonts } from '@custom-components';

export const Content = styled.div`
  font-family: ${fonts.fontRegular} !important;
  padding-top: ${mixins.pxToRem(10)};
  ${media.greaterThan('lg')`
  max-width: ${mixins.pxToRem(900)};
`};
`;

export const TitleSpan = styled.span`
  display: inline-block;
  max-width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
